// @ts-check

const defaultHeaders = {
  Accept: 'application/json',
};

function buildHeaders() {
  const authToken = sessionStorage.getItem('token');
  if (authToken && authToken !== 'undefined') {
    const batchName = sessionStorage.getItem('batchName');
    const xapikey = sessionStorage.getItem('xapikey');
    // const portalID = sessionStorage.getItem('PortalId');
    // const clientsID = sessionStorage.getItem('ClientsID');

    const headers = {
      ...defaultHeaders, // Spread the default headers first
      Authorization: authToken,
      'x-api-key': xapikey,
      // 'X-Tenant-ID': 'rev1',
      // 'X-Clients-ID': '1sk3lla8ni410sumsrchl97g1l',
    };

    // Conditionally add the batchName if it exists
    return batchName ? { ...headers, batchName: batchName } : headers;
  }

  // If there's no valid authToken, return the default headers as is
  return { ...defaultHeaders };
}

const checkData = (response) => {
  if (!response.ok) {
    throw new Error('Network response was not ok: ' + response.statusText);
  }

  return response.json().then((data) => {
    if (data.success === false && data.error) {
      throw new Error(data.error);
    }

    if (data.errorMessage) {
      throw new Error(data.errorMessage);
    }

    return data;
  });
};

const checkError = (error) => {
  console.error('Fetch operation failed:', error);
};

export const restV2Get = async (url, params = {}) => {
  const queryParams = new URLSearchParams(params).toString();
  const endpoint = `${process.env.REACT_APP_API_END_POINT}/api/v2/${url}?${queryParams}`;

  try {
    const response = await fetch(endpoint, {
      method: 'GET',
      headers: buildHeaders(),
    });
    return await checkData(response);
  } catch (error) {
    checkError(error);
    throw error;
  }
};

export const restV2Post = async (url, body = {}) => {
  const endpoint = `${process.env.REACT_APP_API_END_POINT}/api/v2/${url}`;

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        ...buildHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    return await checkData(response);
  } catch (error) {
    checkError(error);
    throw error;
  }
};
